import { useEffect, useState } from "react";
import "./styles.css";

const FullPageLoader = () => {
    return (
        <div className="full" data-testid="loader_full">
            <div className="container">
                <p>myOUTFRONT.com</p>
            </div>
        </div>
    )
}

const OverlayLoader = ({ message }) => {
    return (
        <div className="overlay" data-testid="loader_overlay">
            <div className="container">
                <div className="icon"></div>
                <p>{message}...</p>
            </div>
        </div>
    )
}

const Loader = ({ children, fullPage = false, message = "Loading", loading = false }) => {
    const [loadingState, setLoadingState] = useState(loading);

    useEffect(() => {
        const fullLoader = document.querySelector("#loader .full");
        const overlay = document.querySelector("#loader .overlay");
        if (loadingState && !loading) {
            if (fullPage && fullLoader && fullLoader?.classList) {
                fullLoader?.classList?.add("hide");
            } else if (!fullPage && overlay && overlay?.classList) {
                overlay?.classList?.add("hide");
            }
            setTimeout(() => {
                setLoadingState(false);
            }, 500);
        }
    }, [loading, fullPage, loadingState]);

    return (
        <>
            {!!loadingState && <div id="loader">
                {fullPage ? <FullPageLoader /> : <OverlayLoader message={message} />}
            </div>}
            {children}
        </>
    )
}

export default Loader;